import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederBetalingskalkulatorDto from '../Models/VeilederBetalingskalkulatorDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';

const rootReducer = combineReducers<VeilederBetalingskalkulatorAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    epiContext: (
        state: EpiContext<VeilederBetalingskalkulatorDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederBetalingskalkulatorDto>,
    ): EpiContext<VeilederBetalingskalkulatorDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
});

export type VeilederBetalingskalkulatorAppState = EpiAppStateMedSteg<VeilederBetalingskalkulatorDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
};

export default function configureStore(): Store<VeilederBetalingskalkulatorAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
